export default "__VITE_ASSET__BCG4ZF7F__"